var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"pre-list"},[_c('v-list-item',{attrs:{"to":{ name: 'collectionPoint.detail', params: { id: _vm.$route.params.id } }}},[_c('v-list-item-content',[_vm._v("Odběrné místo")])],1),(
      _vm.collectionPoint.voltageLevel === 'NN' ||
        (_vm.collectionPoint.allowedInstallationAction &&
          _vm.collectionPoint.allowedInstallationAction.name === 'READING')
    )?_c('v-list-item',{attrs:{"to":{ name: 'reportReading.detail', params: { id: _vm.$route.params.id } }}},[_c('v-list-item-content',[_vm._v("Nahlášení odečtu")])],1):_vm._e(),(_vm.collectionPoint.voltageLevel === 'VN' && !_vm.collectionPoint.status && _vm.routeType)?_c('v-list-item',{attrs:{"to":{
      name: _vm.routeType + '.detail',
      params: { id: _vm.$route.params.id },
    }}},[_c('v-list-item-content',[_vm._v("Změna rezervované kapacity")])],1):_vm._e(),(_vm.collectionPoint.voltageLevel === 'VN' && !_vm.collectionPoint.status && !_vm.routeType)?_c('v-list-item',{attrs:{"to":{
      name: 'changeOfReservedCapacity.detail',
      params: { id: _vm.$route.params.id },
    }}},[_c('v-list-item-content',[_vm._v("Změna rezervované kapacity")])],1):_vm._e(),(
      _vm.collectionPoint.allowedInstallationAction &&
        _vm.collectionPoint.allowedInstallationAction.name !== 'READING'
    )?_c('v-list-item',{attrs:{"to":{
      name: 'interruptionOrRenewalOfDistribution.detail',
      params: { id: _vm.$route.params.id },
    }}},[_c('v-list-item-content',[_vm._v("Přerušení / obnovení distribuce elektřiny")])],1):_vm._e(),(_vm.collectionPoint.voltageLevel === 'VN' && !_vm.collectionPoint.status)?_c('v-list-item',{attrs:{"to":{
      name: 'trialOperation.detail',
      params: { id: _vm.$route.params.id },
    }}},[_c('v-list-item-content',[_vm._v("Zkušební provoz")])],1):_vm._e(),(_vm.collectionPoint.voltageLevel === 'VN' && !_vm.collectionPoint.status)?_c('v-list-item',{attrs:{"to":{
      name: 'billingException.detail',
      params: { id: _vm.$route.params.id },
    }}},[_c('v-list-item-content',[_vm._v("Výjimka z fakturace")])],1):_vm._e(),(
      _vm.collectionPoint.voltageLevel === 'NN' &&
      !_vm.collectionPoint.status &&
      _vm.isActiveProcess('REQUEST'))?_c('v-list-item',{attrs:{"to":{
      name: 'requestNN.detail',
      params: { id: _vm.$route.params.id },
    }}},[_c('v-list-item-content',[_vm._v("Žádost NN")])],1):_vm._e(),(
      _vm.collectionPoint.voltageLevel === 'VN' &&
      !_vm.collectionPoint.status &&
      _vm.isActiveProcess('REQUEST'))?_c('v-list-item',{attrs:{"to":{
      name: 'requestVN.detail',
      params: { id: _vm.$route.params.id },
    }}},[_c('v-list-item-content',[_vm._v("Žádost VN")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }